import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { formatStopLocation } from '../../../../shared/utils/run';
import { formatRun } from '../../../../shared/utils/run';

class InsertManifestInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logisticPartners: [],
        };
    }

    render() {
        const { recoveryAction } = this.props;

        if (!recoveryAction) {
            return <span />;
        }

        const { fromLocation, toLocation, impactedRuns } = recoveryAction;

        return (
            <div>
                <Row>
                    <Col sm={4}>
                        <Row>
                            <Col componentClass={ControlLabel} sm={4}>
                                From
                            </Col>
                            <Col sm={8}>{formatStopLocation(fromLocation)}</Col>
                        </Row>
                    </Col>
                    <Col sm={4}>
                        <Row>
                            <Col componentClass={ControlLabel} sm={4}>
                                To
                            </Col>
                            <Col sm={8}>{formatStopLocation(toLocation)}</Col>
                        </Row>
                    </Col>
                    <Col sm={4}>
                        <Row>
                            <Col componentClass={ControlLabel} sm={4}>
                                Impacted runs <br />
                                <small>(Route code - Run seq.)</small>
                            </Col>
                            <Col sm={8}>
                                {impactedRuns.length > 0
                                    ? impactedRuns.map(run => (
                                          <p key={run.runId}>{`${run.routeCode} - ${
                                              run.runSequence
                                          }`}</p>
                                      ))
                                    : 'N/A'}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <Row>
                            <Col componentClass={ControlLabel} sm={4}>
                                Run
                            </Col>
                            <Col sm={8}>{`${formatRun(recoveryAction.run)}`}</Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default InsertManifestInfo;
